export const ANONYMOUS_ID_KEY = 'ajs_anonymous_id'

/** Segment anonymous IDs are opaque strings — accept any non-empty value within a safety cap. */
export const MAX_ANONYMOUS_ID_LENGTH = 100

export function isValidAnonymousId(id: string): boolean {
  return typeof id === 'string' && id.length > 0 && id.length <= MAX_ANONYMOUS_ID_LENGTH
}
